import { useCallback, useEffect, useState } from 'react';
import { loadRoomVisualizeResultSDK } from '@/lib/room-visualize-sdk';
import type { RoomVisualization } from '@/services/generation.service';
import { Button } from '@/components/ui/button';

interface ResultElement extends HTMLElement { record: RoomVisualization; }

export function RoomVisualizeResult({ record, sdkUrl }: { record: RoomVisualization; sdkUrl: string }) {
  const [loadedUrl, setLoadedUrl] = useState('');
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setError(false);
    loadRoomVisualizeResultSDK(sdkUrl).then(() => {
      if (active) setLoadedUrl(sdkUrl);
    }).catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [sdkUrl, attempt]);
  const bind = useCallback((element: HTMLElement | null) => {
    if (element) (element as ResultElement).record = record;
  }, [record]);
  if (error) return <div role="alert" className="space-y-3"><p>The result viewer could not load. Check that the configured SDK includes the saved result viewer.</p><Button onClick={() => setAttempt(value => value + 1)}>Retry viewer</Button></div>;
  if (loadedUrl !== sdkUrl) return <p role="status">Loading result viewer…</p>;
  return <youzu-room-visualize-result ref={bind} lang="en" className="block w-full" />;
}
